import React from 'react';
import { Checkbox, Input } from 'formik-antd';
import FormControl from '~/components/Form/FormControl';
import Button from '~/components/Button';
import i18next from 'i18next';
import { FaTrash } from 'react-icons/fa';
import DateComponent from '~/components/DateComponent';
import { Flex } from 'antd';

export const teamColumns = (errors, fluidPermissions, setFieldValue, handleDelete) => {
  return [
    {
      dataIndex: 'send_message',
      key: 'send_message',
      width: '4%',
      render: (_, record) => (
        <FormControl
          field={`team.${record.originalIndex}.send_message`}
          error={errors?.team?.[record.originalIndex]?.send_message}
          list
          required
          align="center"
          justify="center"
        >
          <Checkbox name={`team.${record.originalIndex}.send_message`} defaultValue={true} />
        </FormControl>
      ),
    },
    {
      title: i18next.t('Nome'),
      dataIndex: 'employee_name',
      key: 'employee_name',
      width: '50%',
      render: (_, record) => (
        <FormControl
          field={`team.${record.originalIndex}.employee_name`}
          error={errors?.team?.[record.originalIndex]?.employee_name}
          list
          required
        >
          <Input name={`team.${record.originalIndex}.employee_name`} disabled />
        </FormControl>
      ),
    },
    {
      title: i18next.t('Horário de saída'),
      dataIndex: 'departure_at',
      key: 'departure_at',
      render: (_, record) => (
        <FormControl
          field={`team.${record.originalIndex}.departure_at`}
          error={errors?.team?.[record.originalIndex]?.departure_at}
          list
          required
        >
          <DateComponent
            value={record?.departure_at}
            onChange={(date) => setFieldValue(`team.${record.originalIndex}.departure_at`, date)}
            disabled={!fluidPermissions()}
            inputReadOnly={false}
            allowClear
            showTime
          />
        </FormControl>
      ),
    },
    {
      title: '',
      key: 'action',
      width: '5%',
      render: (_, record) => (
        <Flex align="center" justify="center">
          <Button
            color="danger"
            title="Remover funcionário"
            size="small"
            style={{ width: '30px' }}
            onClick={() => handleDelete(record.originalIndex)}
            disabled={!fluidPermissions()}
            icon={<FaTrash />}
          />
        </Flex>
      ),
    },
  ];
};
